import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface FormSectionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  style?: any;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  subtitle,
  children,
  style,
}) => {
  // Filter out empty strings and whitespace-only text nodes
  const validChildren = React.Children.toArray(children).filter(child => {
    if (typeof child === 'string') {
      return child.trim() !== '';
    }
    return true;
  });

  const headerContent = React.createElement(
    View,
    { style: styles.header },
    React.createElement(Text, { style: styles.title }, title),
    subtitle ? React.createElement(Text, { style: styles.subtitle }, subtitle) : null
  );

  const contentElement = React.createElement(View, { style: styles.content }, validChildren);

  return React.createElement(
    View,
    { style: [styles.container, style] },
    headerContent,
    contentElement
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: ADMIN_COLORS.SURFACE,
    borderRadius: 12,
    marginBottom: 16,
    overflow: 'hidden',
  },
  header: {
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 8,
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT_PRIMARY,
    marginBottom: 4,
  },
  subtitle: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT_SECONDARY,
    lineHeight: 20,
  },
  content: {
    padding: 16,
  },
});
